// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/index.less
// module id = 3
// module chunks = 12